<template>
  <div>
    <div v-if="editing" class="mb-3">
      <label :for="`youtube_id${component.id}`">YouTube video id</label>
      <input
        type="text"
        placeholder="xxxxxxxxxxx"
        :id="`youtube_id${component.id}`"
        v-model="video"
        class="form-control"
      />
    </div>
    <div v-else-if="youtube_id">
      <div class="ratio ratio-16x9">
        <iframe
          ref="video"
          :src="`https://www.youtube.com/embed/${youtube_id}`"
          frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['component', 'editing'],
  data() {
    return {
      youtube_id: _.get(this.component, 'video', '') || '',
    }
  },
  computed: {
    video: {
      get() {
        return this.youtube_id
      },
      set(data) {
        this.youtube_id = data
        this.component.video = data
      },
    },
  },
}
</script>

